import { Gameplay } from "appworks/model/gameplay/gameplay";
import { RequestBuilder } from "appworks/server/builders/request-builder";
import { PartnerConnectSpinRequestPayload } from "partner-connect/integration/schema/partner-connect-spin-schema";
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";
import { partnerConnectConnector } from "partner-connect/server/connectors/partner-connect-connector";
import { SpinRequestPayload } from "slotworks/model/gameplay/requests/spin-request-payload";
import { slotModel } from "slotworks/model/slot-model";

export class PartnerConnectSpinRequestBuilder implements RequestBuilder {

    public filter(request: SpinRequestPayload): boolean {
        return request instanceof SpinRequestPayload;
    }

    public build(gameplay: Gameplay, request: PartnerConnectSpinRequestPayload) {
        const model = slotModel.read();

        const prepaidInfo = PartnerConnectManager.getGame().getWagerHelper().getPrepaidInfo();
        if (prepaidInfo.isPrepaid && prepaidInfo.betValue) {
            request.creditSize = prepaidInfo.betValue * 100;
        } else {
            request.creditSize = model.bet.creditSizes.currentValue;
        }
        request.creditPerLine = model.bet.creditsPerLine.currentValue;

        if (partnerConnectConnector.pendingCmds?.length > 0) {
            request.cmd = partnerConnectConnector.pendingCmds[0];
        }

        return request;
    }
}

export const partnerConnectSpinRequestBuilder = new PartnerConnectSpinRequestBuilder();
